/**
 * Composant ExtraSlots
 * Gestion des articles supplémentaires (hors sites paramétrés)
 */
import React from 'react';
import { FileText, Trash2 } from 'lucide-react';
import { Input } from '../../components/ui/input';
import { Textarea } from '../../components/ui/textarea';

export const ExtraSlots = ({
  extraSlots,
  showExtraSlots,
  onToggleExtraSlots,
  onAddExtraSlot,
  onRemoveExtraSlot,
  onUpdateExtraSlot,
}) => {
  return (
    <div className="p-3 bg-slate-900/40 border border-slate-700 rounded-lg space-y-3">
      <div className="flex items-center justify-between">
        <label className="text-sm text-slate-300 font-semibold flex items-center gap-2">
          <FileText className="w-4 h-4 text-amber-400" />
          Articles supplémentaires
          <span className="text-xs text-slate-500 font-normal">(hors sites paramétrés, max 3)</span>
        </label>
        {!showExtraSlots ? (
          <button
            type="button"
            onClick={() => { onToggleExtraSlots(true); if (extraSlots.length === 0) onAddExtraSlot(); }}
            className="text-xs font-mono px-3 py-1.5 rounded border bg-amber-500/10 border-amber-500/40 text-amber-400 hover:bg-amber-500/20 transition-all"
            data-testid="btn-show-extra-slots"
          >
            + Ajouter
          </button>
        ) : (
          <button
            type="button"
            onClick={() => onToggleExtraSlots(false)}
            className="text-xs font-mono px-3 py-1.5 rounded border bg-slate-800 border-slate-600 text-slate-400 hover:bg-slate-700 transition-all"
            data-testid="btn-hide-extra-slots"
          >
            Désactiver
          </button>
        )}
      </div>

      {showExtraSlots && (
        <div className="space-y-3">
          {extraSlots.map((slot, idx) => (
            <div key={slot.id} className="p-3 bg-amber-500/5 border border-amber-500/20 rounded-lg space-y-2" data-testid={`extra-slot-${idx}`}>
              <div className="flex items-center justify-between">
                <span className="text-xs font-mono text-amber-400 font-bold">#{idx + 1}</span>
                <button
                  type="button"
                  onClick={() => onRemoveExtraSlot(slot.id)}
                  className="text-xs text-red-400 hover:text-red-300 p-1"
                  data-testid={`extra-slot-remove-${idx}`}
                >
                  <Trash2 className="w-3.5 h-3.5" />
                </button>
              </div>
              <Input
                value={slot.label}
                onChange={(e) => onUpdateExtraSlot(slot.id, 'label', e.target.value)}
                placeholder="Nom / libellé (ex: Blog perso, Newsletter...)"
                className="bg-slate-950/50 border-slate-600 text-slate-200 placeholder:text-slate-600 text-sm h-8"
                data-testid={`extra-slot-label-${idx}`}
              />
              <Textarea
                value={slot.prompt}
                onChange={(e) => onUpdateExtraSlot(slot.id, 'prompt', e.target.value)}
                placeholder="Prompt de rédaction pour cet article..."
                className="bg-slate-950/50 border-slate-600 text-slate-200 placeholder:text-slate-600 text-sm min-h-[60px]"
                data-testid={`extra-slot-prompt-${idx}`}
              />
              <Input
                value={slot.title || ''}
                onChange={(e) => onUpdateExtraSlot(slot.id, 'title', e.target.value)}
                placeholder="Titre imposé (optionnel)"
                className="bg-slate-950/50 border-slate-600 text-slate-200 placeholder:text-slate-600 text-sm h-8"
                data-testid={`extra-slot-title-${idx}`}
              />
            </div>
          ))}
          {extraSlots.length < 3 && (
            <button
              type="button"
              onClick={onAddExtraSlot}
              className="w-full py-2 border-2 border-dashed border-amber-500/30 text-amber-400/60 hover:text-amber-400 hover:border-amber-500/50 rounded-lg text-sm transition-all"
              data-testid="btn-add-extra-slot"
            >
              + Ajouter un article ({extraSlots.length}/3)
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default ExtraSlots;
